var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGhost(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 176.758,
    height: 314.746,
    viewBox: "0 0 176.758 314.746",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ghost",
    transform: "translate(-0.266 -0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28688",
    "data-name": "Path 28688",
    d: "M63.972,355H90.731V391.8l-3.345,6.69h-30.1a3.16,3.16,0,0,1-3.345-3.345V385.108a9.726,9.726,0,0,1,8.028-9.7l2.007-.334Z",
    transform: "translate(-12.468 -84.742)",
    fill: "none",
    stroke: "#170738",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28689",
    "data-name": "Path 28689",
    d: "M65.833,381.414H85.225c4.683,0,8.362,2.007,8.362,6.69v3.345",
    transform: "translate(-15.324 -91.082)",
    fill: "none",
    stroke: "#170738",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28690",
    "data-name": "Path 28690",
    d: "M146.28,355H119.521v40.139a3.16,3.16,0,0,0,3.344,3.345H159.66A3.161,3.161,0,0,0,163,395.143V385.108a9.727,9.727,0,0,0-8.028-9.7l-8.7-.334Z",
    transform: "translate(-28.212 -84.742)",
    fill: "none",
    stroke: "#170738",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28691",
    "data-name": "Path 28691",
    d: "M127.109,44.748a4.014,4.014,0,1,1-4.014-4.014A4.067,4.067,0,0,1,127.109,44.748Z",
    transform: "translate(-28.106 -9.299)",
    fill: "#170738"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28692",
    "data-name": "Path 28692",
    d: "M150,44.748a4.014,4.014,0,1,1-4.013-4.014A4.316,4.316,0,0,1,150,44.748Z",
    transform: "translate(-33.601 -9.299)",
    fill: "#170738"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28693",
    "data-name": "Path 28693",
    d: "M48.16,82.278V42.139a40.139,40.139,0,1,1,80.278,0V82.278c15.722,53.519,31.108,107.372,46.829,160.89a35.035,35.035,0,0,1-22.076,5.687,34.424,34.424,0,0,1-16.056-5.687,29.529,29.529,0,0,1-17.058,5.687,28.846,28.846,0,0,1-17.394-5.687,26.823,26.823,0,0,1-17.728,5.687,26.955,26.955,0,0,1-16.39-5.352,29.712,29.712,0,0,1-16.725,5.352,26.956,26.956,0,0,1-16.39-5.352,29.393,29.393,0,0,1-16.39,5.352A29.531,29.531,0,0,1,2,243.168C16.718,189.65,32.439,135.8,48.16,82.278Z",
    fill: "none",
    stroke: "#170738",
    strokeWidth: 3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGhost);
export default __webpack_public_path__ + "static/media/ghost.26fce0efe4453f428508d550425b65bc.svg";
export { ForwardRef as ReactComponent };